import { ROUTES } from '../../constants/routes'

export const titles: Record<string, string> = {
  [ROUTES.SETTINGS]: 'Settings',
  [ROUTES.CLIENT_SETTINGS_NOTIFICATIONS]: 'Settings',
  [ROUTES.SETTINGS_PROFILE]: 'Settings',
  [ROUTES.APPLICATION_PAGE]: 'Application Progress',
  [ROUTES.DOCUMENTS_PAGE]: 'Documents',
  [ROUTES.SETTINGS_SECURITY]: 'Settings',
  [ROUTES.HOMEPAGE]: 'Overview',
  [ROUTES.FUNDING]: 'Funding',
  [ROUTES.SUBMIT_REPORTING]: 'Reporting',
  [ROUTES.ACCOUNT_ACTIVITY]: 'Activity',
  [ROUTES.NOTIFICATIONS]: 'Notifications',
  [ROUTES.CLIENT_VISUALIZATIONS]: 'Analytics',
  [ROUTES.CLIENT_SUBMIT_REPORTING_PAGE]: 'Ongoing Reporting',
}
